<template>
    <DModal
        :title="__('settings.communication_subscription_types.edit')"
        :show="showModal"
        is-confirm
        @confirm="submitForm"
        @close="emit('close-modal')"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('settings.communication_subscription_types.table.name')"
                :hint="__('settings.communication_subscription_types.table.name_hint')"
            >
                <p>
                    {{ __('settings.communication_subscription_types.types.' + type.name) }}
                </p>
                <TranslationLink
                    :tenant-languages="tenantLanguages"
                    :route="route('settings.communication-subscription-types.translations', {communicationSubscriptionType: type.id})"
                    :default-tenant-language="defaultTenantLanguage"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.communication_subscription_types.table.identifier')"
                :error="errors?.identifer"
                :hint="__('settings.communication_subscription_types.table.identifier_hint')"
            >
                <DInput
                    id="communication-subscription-types-identifier"
                    v-model="form.identifier"
                    type="input"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { ref } from 'vue'
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import TranslationLink from '../TranslationLink.vue'

const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    type: {
        type: Object,
        default: () => { return {} }
    },
    defaultTenantLanguage: {
        type: Object,
        default: () => { return {} }
    },
    tenantLanguages: {
        type: Array,
        default: () => { return [] }
    }
})

const form = useForm({
    identifier: props.type?.identifier ?? null
})

const errors = ref([])
const emit = defineEmits(['close-modal'])

function submitForm () {
    form.patch(route('settings.communication-subscription-types.update', { communicationSubscriptionType: props.type.id }), {
        onSuccess: () => {
            emit('close-modal')
        },
        onError: (error) => {
            errors.value = error
        },
        preserveState: false
    })
}
</script>
